import { useEffect } from "react";
import { FcFilingCabinet } from "react-icons/fc";
import { useMatch } from "react-router-dom";
import { Center, Icon, useDisclosure } from "@chakra-ui/react";
import { CardBody } from "@paljs/ui/Card";
import { useQuery } from "graphql-hooks";
import _ from "lodash";

import { GenericErrorAlert } from "../../components/alerts";
import EmptyState from "../../components/empty-state";
import Layout from "../../components/layout";
import Loading from "../../components/loading";
import SuccessBuyModal from "../../components/modals/successBuy";
import { Card, Col } from "../../components/paljs";
import {
  ADD_MEMBERSHIP_ITEM,
  PLACE_ORDER,
  UPDATE_CHILD,
  UPDATE_ME,
} from "../../data/mutations";
import { GET_ARCHIVE_ORDERS } from "../../data/queries";
import usePaymentConfirmation from "../../hooks/usePaymentConfirmation";
import PaymentConfirmationBanner from "../../components/payment-confirmation";
import { GetArchiveOrdersQuery, Order } from "../../types";

import OrderCard from "./components/order-card";

const Archive = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { loading, data, error, refetch } = useQuery<GetArchiveOrdersQuery>(
    GET_ARCHIVE_ORDERS,
    {
      refetchAfterMutations: [
        UPDATE_ME,
        UPDATE_CHILD,
        ADD_MEMBERSHIP_ITEM,
        PLACE_ORDER,
      ],
      useCache: false,
    }
  );

  const matchPath = useMatch({
    path: "/archive/:orderId/:paymentId",
    caseSensitive: false,
    end: false,
  });

  const paymentState = usePaymentConfirmation(
    data?.me.archiveOrders,
    matchPath?.params.orderId,
    matchPath?.params.paymentId,
    refetch
  );

  // Thank the customer only once the payment is actually confirmed
  useEffect(() => {
    if (paymentState === "confirmed") onOpen();
  }, [paymentState, onOpen]);

  return (
    <Layout>
      <Center>
        <Col breakPoint={{ sm: 12, lg: 12, xl: 10, xxl: 9, xxxl: 9 }}>
          <>
            <PaymentConfirmationBanner state={paymentState} />
            {(loading && !data) || error ? (
              <>
                <Card>
                  <CardBody>
                    {loading && <Loading />}
                    {error && <GenericErrorAlert />}
                  </CardBody>
                </Card>
              </>
            ) : null}
            {data?.me.archiveOrders && (
              <>
                {!loading && _.isEmpty(data.me.archiveOrders) && (
                  <EmptyState
                    header={"Brak archiwalnych zamówień"}
                    icon={<Icon boxSize="10em" as={FcFilingCabinet}></Icon>}
                    text="Skontaktuj się z koordynator w celu wprowadzenia nowego zamówienia"
                  />
                )}
                {_.map(data.me.archiveOrders, (order) => {
                  return <OrderCard order={order as Order} key={order.id} />;
                })}
              </>
            )}
          </>
        </Col>
      </Center>
      <SuccessBuyModal onClose={onClose} isOpen={isOpen} />
    </Layout>
  );
};

export default Archive;
